import React from 'react';

import { Apollo } from 'src/gql/generated';
import type { WorkflowStep } from 'src/workflow';
import { ActionGroupElement, getWorkflowWasSentForSig, useDropAction } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

interface StyleProps {
  isOver: boolean;
  isStepEditable: boolean;
}

export const useStepStyles = makeStyles<StyleProps>()((theme, { isOver, isStepEditable }) => ({
  step: {
    border: isStepEditable
      ? isOver
        ? `1px dashed ${theme.palette.primary.main}`
        : `1px dashed ${theme.appColors.rule}`
      : `1px solid ${theme.appColors.rule}`,
    borderRadius: 16,
    boxSizing: 'border-box',
  },
}));

interface StepElementProps {
  isActiveGroup: boolean;
  step: WorkflowStep;
  stepNumber: number;
  workflowId: UUID;
  workflowState: Apollo.WorkflowState;
}

export function StepElement({
  isActiveGroup,
  step,
  stepNumber,
  workflowId,
  workflowState,
}: StepElementProps): JSX.Element {
  const [{ isOver: isActionOver }, actionDropRef] = useDropAction({
    actionPlacement: Apollo.ActionPlacement.WithinStep,
    targetStepId: step.id,
    workflowId,
  });
  const wasSentForSignature = getWorkflowWasSentForSig({
    __typename: 'Workflow',
    state: workflowState,
  });
  const { classes } = useStepStyles({ isOver: isActionOver, isStepEditable: !wasSentForSignature });

  return (
    <div ref={actionDropRef} className={classes.step}>
      <ActionGroupElement
        isActiveGroup={isActiveGroup}
        step={step}
        stepNumber={stepNumber}
        workflowId={workflowId}
        workflowState={workflowState}
      />
    </div>
  );
}
